<template>
    <NavbarMain :first-page="false" />

    <GdprPage :section_title="section_title_en" :gdpr_policy="gdpr_policy_en" />

    <FooterPage />
</template>

<script>
import axios from 'axios';

import NavbarMain from '../components/NavbarMain.vue'
import FooterPage from '../components/FooterPage.vue'
import GdprPage from '@/components/GdprPage.vue';

export default {
    components: {
        NavbarMain,
        FooterPage,
        GdprPage
    },
    data() {
        return {
            gdprData: { items_en: [{}] },
            section_title_en: '',
            gdpr_policy_en: '',
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/gdpr-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.gdprData = response.data || { items_en: [] };

                if (this.gdprData.items_en[0]?.active === true) {
                    this.section_title_en = this.gdprData.items_en[0].section_title;
                    this.gdpr_policy_en = this.gdprData.items_en[0].gdpr_policy;
                }
            })
            .catch(error => {
                console.error('Error fetching GDPR data:', error);
            });
    }
}
</script>

<style></style>
